//* Libraries imports
import { useState, useCallback } from "react";

//* Service imports
import { customerAsaasService } from "@/services/asaas/customerService";

//* Types imports
import type { ApiError } from "@/types/api";
import type { CreateCustomerAsaasDTO, CustomerResponseAsaasDTO } from "@/schemas/asaas/customer";

export const useCreateCustomer = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const create = useCallback(async (data: CreateCustomerAsaasDTO) => {
    setLoading(true);
    setError(null);
    try {
      const response = await customerAsaasService.create(data);

      if ("code" in response && "message" in response) {
        const apiError = response as ApiError;
        throw new Error(apiError.message);
      }

      if ("data" in response) {
        return response.data as CustomerResponseAsaasDTO;
      }
    } catch (err: any) {
      const errorMessage = err.message || "Ocorreu um erro ao criar o cliente no Asaas";
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { create, loading, error };
};
